import { createContext, useState } from 'react';
import { INVOICE_TABS, InvoiceTab } from '../constants/enums';

type TabContextType = {
  tabSelected: InvoiceTab;
  setTabSelected: (tab: InvoiceTab) => void;
};

const TabContext = createContext<TabContextType>({
  tabSelected: INVOICE_TABS.PENDING,
  setTabSelected: () => {},
});

const TabProvider = ({ children }: React.PropsWithChildren): JSX.Element => {
  const [tabSelected, setTabSelected] = useState<InvoiceTab>(INVOICE_TABS.PENDING);

  return <TabContext.Provider value={{ tabSelected, setTabSelected }}>{children}</TabContext.Provider>;
};

export default TabContext;
export { TabProvider };
